module.exports = __webpack_public_path__ + "img/event-solo-venere-avril-juin-2025.0b3344e.jpg";